import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import SensorsField from '../../../../../features/export/ExportDataBySensors/ExportDataBySensorsForm/Fields/SensorsField/SensorsField';
import {
  useGetAppUserResourceIdQuery,
  usePatchAppUserResourceMutation,
} from '../../../../../entities/account/appUsersResource/redux/appUsersResource.api';
import useAuth from '../../../../../shared/lib/hooks/useAuth';

function AddSensorsPopup({ open, onClose, value, onApply, vehicleId }) {
  const [localSensors, setLocalSensors] = useState(value);

  const { user } = useAuth();
  const { data: dataAppUserResourceId } = useGetAppUserResourceIdQuery({
    id: user.appUserId,
  });
  const appUser = dataAppUserResourceId?.data;

  const [patchAppUserResource] = usePatchAppUserResourceMutation();

  useEffect(() => setLocalSensors(value), [value]);

  const handleApply = () => {
    onApply(localSensors);
    patchAppUserResource({
      id: appUser.appUserId,
      body: {
        ...appUser,
        customAugmentationEx: {
          ...(appUser.customAugmentationEx || {}),
          view: { vsensor: localSensors?.map((ls) => ls.sensorTypeId)?.join(',') },
        },
      },
    });
    onClose();
  };

  const handleClose = () => {
    setLocalSensors(value);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Выбор сенсоров</DialogTitle>

      <DialogContent dividers>
        <SensorsField data={localSensors} setData={setLocalSensors} vehicleId={vehicleId}/>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Отмена</Button>
        <Button variant="contained" onClick={handleApply}>
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AddSensorsPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onApply: PropTypes.func.isRequired,
  vehicleId: PropTypes.number
};

AddSensorsPopup.defaultProps = {
  vehicleId : null
}

export default AddSensorsPopup;
